enum QueuedExportSubTypes {
    CSV = 0,
    TD_CSV = 1,
    XLSX = 2,
    GAv8 = 3,
    GAv9 = 4,
    TD_Simon = 5,
    EWorkspace = 6,
    V8 = 7,
    V9 = 8,
    Undefined = 9
}

export default QueuedExportSubTypes;